// helper.js — pure utilities for LegalEntityManagement and its sub-components.

export const getInitials = (label = "") => {
  const before = String(label).split(" - ")[0]?.trim();
  if (before && before.length <= 3) return before.toUpperCase();
  const words = String(label).replace(/[^\w\s]/g, "").trim().split(/\s+/);
  return (words[0]?.[0] ?? "?").toUpperCase() + (words[1]?.[0] ?? "").toUpperCase();
};

export const countFunctions = (entity) =>
  (entity?.business_units || []).reduce(
    (acc, bu) => acc + (bu?.functions?.length || 0),
    0,
  );

export const countSubFunctions = (entity) =>
  (entity?.business_units || []).reduce(
    (acc, bu) =>
      acc +
      (bu?.functions || []).reduce(
        (a, fn) => a + (fn?.sub_functions?.length || 0),
        0,
      ),
    0,
  );

export const cloneStructure = (list) =>
  (list || []).map((e) => ({
    ...e,
    currency_info: { ...(e.currency_info || {}) },
    locations: (e.locations || []).map((l) => ({ ...l })),
    business_units: (e.business_units || []).map((bu) => ({
      ...bu,
      functions: (bu.functions || []).map((fn) => ({
        ...fn,
        sub_functions: (fn.sub_functions || []).map((sf) => ({ ...sf })),
      })),
    })),
  }));
